<template>
  <BasicConfigurator :value="imagesForBasicConfigurator"
                     :product="product"
                     :configuration-valid="value.length > 0"
                     :choices="prefill && prefill.choices"
                     @addedToBasket="onAddedToBasket"
                     @backToProducts="$emit('backToProducts')"
                     @error="onError"
                     @reset="resetConfiguration"
  >
    <v-row v-if="!basketProductSubmission || !basketProductSubmission.editing" dense>
      <v-col cols="auto">
        <v-switch v-model="selectMultiple" :label="$t('CONFIGURATOR_CHOOSE_MULTIPLE')" class="multipleSwitch"/>
      </v-col>
      <v-col cols="auto" class="help-tooltip-container">
        <HelpTooltip inline>{{ $t("CONFIGURATOR_CHOOSE_MULTIPLE_HINT") }}</HelpTooltip>
      </v-col>
    </v-row>
    <ImageSelector :value="selectedImageOrImages"
                   :images="eligibleImages"
                   :product-id="product.id"
                   :multiple="selectMultiple"
                   :filter="product.imageFilter"
                   @input="onSelect"/>
  </BasicConfigurator>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import BasicConfigurator from "@/components/product-configuration/BasicConfigurator.vue";
import ImageSelector from "@/components/product-configuration/ImageSelector.vue";
import {Prop} from "vue-property-decorator";
import {ConfiguredImageDto, ImageDto, ImageRequirementDto, ProductDto} from "@swagger";
import HelpTooltip from "@/components/HelpTooltip.vue";
import {ProductConfigurationPrefill} from '@/global/ProductConfigurationPrefill';

@Component({
  components: {HelpTooltip, ImageSelector, BasicConfigurator}
})
export default class SingleConfigurator extends BasicComponent {

  @Prop(Array) value: ConfiguredImageDto[];
  @Prop(Object) product: ProductDto;
  @Prop(Object) prefill: ProductConfigurationPrefill;

  selectMultiple: boolean = false;
  selected: ConfiguredImageDto[] =  [];

  get selectedImageOrImages(): ConfiguredImageDto | ConfiguredImageDto[] {
    if (this.selectMultiple) {
      return this.value;
    }
    return this.value[0];
  }

  get eligibleImages(): ImageDto[] {
    return this.$store.getters.imageSelection.images.filter((image: ImageDto) => {
      return this.imageMatchesRequirement(image, this.requirement)
          && this.allPersons.some(person => (!this.prefill || this.prefill.personCodes.includes(person.code))
            && person.imageIds.includes(image.uniqueId) && person.productIds.includes(this.product.id)); // At least one person having this image must be eligible for this product
    });
  }

  get requirement(): ImageRequirementDto {
    return this.product.imageRequirements[0];
  }

  get imagesForBasicConfigurator(): ConfiguredImageDto[][] {
    let images = this.value;
    if (! this.selectMultiple && this.value.length > 0) {
      images = [this.value[0]];
    }
    return images.map(image => [image]);
  }

  onSelect(images: ConfiguredImageDto[]): void {
    const selected = Array.isArray(images) ? images : [images];
    this.selected = selected;
    this.$emit("input", selected);
  }

  onAddedToBasket(items): void {
    this.$emit("addedToBasket", items);
  }

  onError(error): void {
    this.$emit("error", error);
  }

  resetConfiguration() {
    this.$emit("input", []);
  }

}

</script>
<style lang="scss" scoped>
.multipleSwitch {
  display: inline-block;
  margin-top: 0;
  margin-right: 10px;
  transform: translateY(4px);
}

.help-tooltip-container {
  display: flex;
  align-items: center;
  transform: translateY(-5px);
}
</style>
<style lang="scss">

</style>
